export const SELECT_FROM_ASSIGNED = 0; // select from cities assigned to user in DB
export const SELECT_FROM_ALL = 1;

// Tells what button text to show for each state
export const selectionButtonLabels = {
  [SELECT_FROM_ASSIGNED]: 'Advanced',
  [SELECT_FROM_ALL]: 'Back',
};

export const COUNTY = 'COUNTY';
export const CITY = 'CITY';
